export default {
  path: '/esg',
  title: 'ESG统计',
  title_EN: 'ESG Statistics',
  icon: 'mdi-chart-box-outline',
  access: 'ESG统计',

  children: [
    {
      title: '海务',
      icon: 'mdi-waves',
      group: '/sea',
      children: [
        {
          path: '/esg/typhoon-influence-list',
          name: 'typhoon-influence-list',
          component: () =>
            import('@/views/maritime-affairs/esg/typhoon-influence-list'),
          meta: {
            title: '台风影响',
            access: 'ESG台风影响:列表',
          },
        },
        {
          path: '/esg/pressure-influence-list',
          name: 'pressure-influence-list',
          component: () =>
            import('@/views/maritime-affairs/esg/pressure-influence-list'),
          meta: {
            title: '冷高压影响',
            access: 'ESG冷高压影响:列表',
          },
        },
        {
          path: '/esg/cyclone-influence-list',
          name: 'cyclone-influence-list',
          component: () =>
            import('@/views/maritime-affairs/esg/cyclone-influence-list'),
          meta: {
            title: '气旋影响',
            access: 'ESG气旋影响:列表',
          },
        },
        {
          path: '/esg/fog-influence-list',
          name: 'fog-influence-list',
          component: () =>
            import('@/views/maritime-affairs/esg/fog-influence-list'),
          meta: {
            title: '大雾及军演影响',
            access: 'ESG大雾及军演影响:列表',
          },
        },
        {
          path: '/esg/harmless-waste',
          name: 'harmless-waste',
          component: () =>
            import('@/views/maritime-affairs/esg/harmless-waste'),
          meta: {
            title: '无害垃圾',
            access: 'ESG无害垃圾:列表',
          },
        },
        {
          path: '/esg/harmful-waste',
          name: 'harmful-waste',
          component: () => import('@/views/maritime-affairs/esg/harmful-waste'),
          meta: {
            title: '有害垃圾',
            access: 'ESG有害垃圾:列表',
          },
        },
        {
          path: '/esg/fresh-water',
          name: 'fresh-water',
          component: () => import('@/views/maritime-affairs/esg/fresh-water'),
          meta: {
            title: '淡水',
            access: 'ESG淡水:列表',
          },
        },
        {
          path: '/esg/ballast-water',
          name: 'ballast-water',
          component: () => import('@/views/maritime-affairs/esg/ballast-water'),
          meta: {
            title: '压载水',
            access: 'ESG压载水:列表',
          },
        },
        // {
        //   path: '/esg/pressure-influence-detail/:id',
        //   name: 'pressure-influence-detail',
        //   component: () =>
        //     import('@/views/maritime-affairs/esg/pressure-influence-detail'),
        //   meta: {
        //     title: '冷高压影响详情',
        //     access: '冷高压影响:列表',
        //     notShowInNav: true,
        //   },
        // },
      ],
    },
    {
      title: '机务',
      icon: 'mdi-hammer-wrench',
      group: '/sea',
      children: [
        {
          path: '/esg/harmless-water',
          name: 'harmless-water',
          component: () =>
            import('@/views/maritime-affairs/esg/harmless-water'),
          meta: {
            title: '运营废水',
            access: '运营废水:列表',
          },
        },
        {
          path: '/esg/case-clean',
          name: 'case-clean',
          component: () => import('@/views/maritime-affairs/esg/case-clean'),
          meta: {
            title: '船底(外壳)清洗',
            access: '船底(外壳)清洗:列表',
          },
        },
        {
          path: '/esg/oil-count',
          name: 'oil-count',
          component: () => import('@/views/maritime-affairs/esg/oil-count'),
          meta: {
            title: '滑油消耗统计',
            access: '滑油消耗统计:列表',
          },
        },
        {
          path: '/esg/paint-count',
          name: 'paint-count',
          component: () => import('@/views/maritime-affairs/esg/paint-count'),
          meta: {
            title: '油漆消耗统计',
            access: '油漆消耗统计:列表',
          },
        },
      ],
    },
  ],
}
